<template>
  <button variant="blank" class="font-bold">
    <svg
      class="w-6 md:w-6 2xl:w-6"
      viewBox="0 0 27 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.33203"
        y="1.41406"
        width="24"
        height="38.3448"
        rx="12"
        stroke="currentColor"
        stroke-width="2"
      />
      <path
        d="M13.332 8.03516V15.6558"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        class="animate-slide-down"
      />
    </svg>

    <span v-if="slots.default" class="ml-4 inline-block">
      <slot />
    </span>
  </button>
</template>

<script lang="ts" setup>
const slots = useSlots()
</script>

<style scoped>
.animate-slide-down {
  animation: slideDown 2s infinite;
}

@keyframes slideDown {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
